export const DefaultErrorMessage = "Something went wrong, Please try again later";
